import { useRef } from "react"
import { motion, useScroll, useTransform, useReducedMotion } from "framer-motion"

/**
 * Big AJP Group logo used as a background watermark.
 * - mix-blend-screen makes the logo's black backdrop vanish on dark sections
 * - drifts with scroll (parallax) and floats gently
 * Place it as the first child of a `relative isolate` section.
 */
export default function LogoWatermark({ opacity = 0.25, className = "" }) {
  const ref = useRef(null)
  const reduce = useReducedMotion()
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] })
  const y = useTransform(scrollYProgress, [0, 1], reduce ? ["0%", "0%"] : ["-14%", "14%"])
  const scale = useTransform(scrollYProgress, [0, 0.5, 1], reduce ? [1, 1, 1] : [0.92, 1.04, 0.92])

  return (
    <div
      ref={ref}
      aria-hidden
      className={`pointer-events-none absolute inset-0 -z-10 mix-blend-screen flex items-center justify-center overflow-hidden ${className}`}
    >
      {/* scroll parallax */}
      <motion.div style={{ y, scale }} className="w-[170%] max-w-[1500px] sm:w-[120%]">
        {/* slow float */}
        <motion.div
          animate={reduce ? undefined : { y: [0, -14, 0] }}
          transition={{ duration: 9, ease: "easeInOut", repeat: Infinity }}
        >
          {/* fade-in on view */}
          <motion.img
            src="/assets/logos/AJP%20Logo%202.png"
            alt=""
            draggable={false}
            initial={{ opacity: 0, scale: 1.08 }}
            whileInView={{ opacity, scale: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
            className="block h-auto w-full select-none"
          />
        </motion.div>
      </motion.div>
    </div>
  )
}
